<ng-container *cdkPortal>
  <a [routerLink]="url()">
    <mat-icon>arrow_back_ios_new</mat-icon>
    <span>Back</span>
  </a>
</ng-container>
